import React from 'react';
import Slider from 'react-slick';

import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

import './BackgroundCarousel.css';

// TODO : - Home Images goes here
const images = [
  '/images/bg.avif',
  // 'https://images.unsplash.com/photo-1536570729710-552e7eb8ff1c?q=80&w=1800&auto=format&fit=crop',
  // 'https://images.unsplash.com/photo-1536570729710-552e7eb8ff1c?q=80&w=1700&auto=format&fit=crop',
];

const BackgroundCarousel = () => {
  const settings = {
    dots: false,        // Hide the dots
    infinite: true,     // Loop the carousel
    fade: true,         // Use a fade transition instead of a slide
    speed: 1500,        // Transition speed in ms
    autoplay: true,     // Automatically change slides
    autoplaySpeed: 5000,// Time between slides in ms
    cssEase: 'ease-in-out',
    pauseOnHover: false,
    arrows: false,      // Hide the navigation arrows
  };

  return (
    <div className="background-carousel">
      <Slider {...settings}>
        {images.map((img, index) => (
          <div key={index}>
            <div 
              className="background-slide" 
              style={{ backgroundImage: `url(${img})` }}
            ></div>
          </div>
        ))}
      </Slider>
      <div className="background-overlay"></div>
    </div>
  );
};

export default BackgroundCarousel;
